// Imports => Dependencies
import React, { createContext } from 'react';
import { makeObservable, observable, computed, action, runInAction } from 'mobx';

// Imports => API
import API from '@api';

// Imports => Stores

import AuthStore from '@stores/auth.store';
import FaqStore from '@stores/faq.store';
import FilesStore from '@stores/files.store';
import KpisStore from '@stores/kpis.store';
import NewsStore from '@stores/news.store';
import ProfileStore from '@stores/profile.store';
import ProjectsStore from '@stores/projects.store';
import ProjectUpdatesStore from '@stores/project-updates.store';

import UiStore from '@stores/ui.store';
import ToastersStore from '@stores/toasters.store';

class Store {
	constructor(config) {
		makeObservable(this);

		this.config = config;

		this.api = new API(config, this);

		this.auth = new AuthStore(this);
		this.faq = new FaqStore(this);
		this.files = new FilesStore(this);
		this.kpis = new KpisStore(this);
		this.news = new NewsStore(this);
		this.profile = new ProfileStore(this);
		this.projects = new ProjectsStore(this);
		this.project_updates = new ProjectUpdatesStore(this);

		this.ui = new UiStore(this);
		this.toasters = new ToastersStore(this);

		window.addEventListener(
			'swFreshContentReady',
			this.handleSWFreshContentReady,
			true
		);
		window.addEventListener('swCacheReady', this.handleSWCacheReady, true);
	}

	@action
	resetStores = () => {
		return new Promise((resolve) => {
			resolve();
		});
	};

	@observable
	swUpdated = false;

	@observable
	freshContentReady = false;

	@computed
	get freshContentIsAvailable() {
		return this.freshContentReady;
	}

	@action
	handleSWFreshContentReady = (event) => {
		runInAction(() => {
			this.freshContentReady = true;
		});
	};

	@action
	handleSWCacheReady = (event) => {
		this.toasters.add({
			variant: 'info',
			title: 'Cache is gereed',
			description:
				'Assets en resources zijn in de cache opgeslagen voor offline gebruik.',
		});
	};
}

export default Store;
